// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const isValidVideoUrl = (value: string, acceptExternal = false): boolean => {
    if (!value?.trim()) {
        return false;
    }

    const lower = value.toLowerCase();

    // Common video file extensions
    const videoExtensions = [".mp4", ".webm", ".ogg"];

    // Common external video domains
    const externalDomains = ["youtube.com", "youtu.be", "vimeo.com"];

    // Local files only
    if (!acceptExternal) {
        return videoExtensions.some(ext => lower.endsWith(ext) || lower.includes(`${ext}`));
    }

    // Accept both local files and external sources
    return (
        videoExtensions.some(ext => lower.endsWith(ext) || lower.includes(`${ext}?`)) ||
        externalDomains.some(domain => lower.includes(domain))
    );
};

export const isVideoIframe = (url?: string) => {
    if (!url) {
        return false;
    }

    const lower = url.toLowerCase();
    return lower.includes("youtube.com") || lower.includes("youtu.be") || lower.includes("vimeo.com");
};
